module.exports = __webpack_public_path__ + "static/media/ucpb.2c4e79c2.svg";